import type { FieldValues, Control, Path } from 'react-hook-form'

import { FormField, FormItem } from 'src/shared/components/ui/forms/form'
import { InputOTP, InputOTPGroup, InputOTPSlot } from 'src/shared/components/ui/inputs/input-otp'
import { cn } from 'src/shared/utils/cn'

interface CodeFormFieldProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>
  name: Path<TFieldValues>
  className?: string
  length?: number
}

export const CodeFormField = <TFieldValues extends FieldValues>({
  control,
  name,
  className,
  length = 6,
}: CodeFormFieldProps<TFieldValues>) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormItem>
            <div className={cn('flex items-center justify-center', className)}>
              <InputOTP maxLength={length} value={field.value || ''} onChange={(value) => field.onChange(value)}>
                <InputOTPGroup>
                  {Array.from({ length }).map((_, index) => (
                    <InputOTPSlot key={index} index={index} />
                  ))}
                </InputOTPGroup>
              </InputOTP>
            </div>
          </FormItem>
        )
      }}
    />
  )
}
